// react core
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom';

// conf
import conf from 'conf/ajax';

// utils
import {
    add_params_to_uri
} from 'commons/utils';

export default function QASearcher(props)
{
    const [value, setValue] = useState('');
    const navigate = useNavigate();

    // reading text from locaiton
    const history = useLocation();
    window.$H = history;

    useEffect(() =>
    {
        const url = new URL(window.location.href);
        const text = url.searchParams.get("text");
        if(text !== null) setValue(text); else setValue('');
    }, [history.search]);

    const fireQuery = () =>
    {
        // we are on question list
        if(history.pathname === conf.route.answer)
        {
            const data = add_params_to_uri(
            {
                text: value.trim()
            });
            navigate(data.url);
        }
        else
        {
            // simplify mode, we force text search
            navigate(conf.route.answer + `?text=${value.trim()}`);
        }
    };

    const handleTextChange = (evt) =>
    {
        setValue(evt.target.value);
    };

    const handleTextonKeyUp = (evt) =>
    {
        if (evt.charCode === 13)
        {
            fireQuery();
        }
    };

    const handleTextClick = (evt) =>
    {
        fireQuery();
    };

    let main_title = () =>
    {
        return (
            <div className="input-group">
                <div className='search-bar'>
                    <input type="text" className="form-control js-main-searcher"
                        value={value}
                        placeholder="Browse an already asked question or ask a new one"
                        onChange={handleTextChange}
                        onKeyPress={handleTextonKeyUp} />
                </div>
                <span className="input-group-btn">
                    <button className="button button-primary" onClick={handleTextClick} type="button"><i className="ui-icon-search"></i></button>
                </span>
            </div>
        );
    };

    return (
        <>
            <div className="row" id="row-header">
                <div className="col-md-12">
                    <div className="section-title alt">
                        <h2><Link className='home-button' to={conf.route.answer}><i className="ui-icon-help"></i>Q&A</Link></h2>
                        <div className="section-title-form">
                            {main_title()}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
